<script setup lang="ts">
import CloseIcon from '@/assets/icons/close.svg?component'
import BackIcon from '@/assets/icons/interface/back.svg?component'
import { useAppMode } from '@/composables/useAppMode'

defineProps<{
  onClose?: () => void
  onBack?: () => void
  showBackLabel?: boolean
}>()

defineEmits<{
  close: []
  back: []
}>()

const { mode } = useAppMode()
</script>

<template>
  <div class="panel-title">
    <button
      v-if="onBack"
      type="button"
      class="panel-title__back"
      @click.stop.prevent="$emit('back')"
    >
      <back-icon /><template v-if="showBackLabel"> &nbsp;Back </template>
    </button>
    <div class="panel-title__content text-lg lg:text-3xl">
      <slot />
    </div>
    <button
      v-if="onClose"
      type="button"
      class="panel-title__close"
      @click.stop.prevent="$emit('close')"
    >
      <close-icon />
    </button>
    <!-- <hr class="panel-title__separator" /> -->
  </div>
</template>

<style lang="scss">
.panel-title {
  width: 100%;
  color: var(--wpt-text-white, #fff);
  text-align: center;
  font-size: 16px;
  font-weight: 500;

  &__content {
    padding: 14px 0;
  }

  &__separator {
    margin: 0 20px;
    border: none;
    border-bottom: 1px solid #303144;
  }

  &__close {
    position: absolute;
    right: 13px;
    top: 13px;
    padding: 8px;
    background-color: transparent;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  &__back {
    display: flex;
    align-items: center;
    color: white;
    position: absolute;
    left: 13px;
    top: 12px;
    padding: 8px;
    background-color: transparent;
    border: none;
    cursor: pointer;
  }
}
</style>
